<template>
        <section class="my-lg-5 my-4">
            <div class="container">
                <div class="my-lg-5 my-4">
                    <img src="https://cdn.studiesweekly.com/store/productpage-ext_03.jpg" class="img-fluid w-100">
                </div>

                <div class="my-lg-5 my-4">
                    <div class="row">
                        <div class="col-lg-6 align-self-center mb-lg-0 mb-3">
                            <img src="https://cdn.studiesweekly.com/store/productpage-ext_06.jpg" class="img-fluid w-100">
                        </div>
                        <div class="col-lg-6 align-self-center">
                            <h5>New Generation of Student Materials</h5>
                            <p>Say goodbye to your old-fashioned textbooks. Studies Weekly's highly engaging, student-centric content brings learning to life for every child.</p>
                            <!-- <button type="button" class="btn btn-outline-primary">Preview Publication</button> -->
                        </div>
                    </div>
                </div>

                <div class="my-lg-5 my-4">
                    <div class="row">
                        <div class="col-lg-6 align-self-center order-lg-1 order-2">
                            <h5>Interactive, Consumable, Kid-Approved</h5>
                            <ul class="list-group mb-3">
                                <li class="list-group-item">Cut out sections for focus learning (<strong>ELL</strong>, <strong>ESE</strong>, <strong>504 Plan</strong>)</li>
                                <li class="list-group-item">Purple highlighted text addresses the needs of the three most common forms of <strong>color blindness</strong></li>
                                <li class="list-group-item"><strong>Close reading</strong> - Highlight, star, circle, underline, and annotate the text.</li>
                            </ul>
                            <button type="button" class="btn btn-outline-primary" @click.prevent="showModal('interactive-consumable-modal')">Watch Video</button>
                        </div>
                        <div class="col-lg-6 align-self-center mb-lg-0 mb-3 order-lg-2 order-1">
                            <img src="https://cdn.studiesweekly.com/store/productpage-ext_10.jpg" class="img-fluid w-100">
                        </div>
                    </div>

                    <b-modal id="interactive-consumable-modal" size="lg" hide-footer centered>
                        <template v-slot:modal-header>
                            <button type="button" class="close" aria-label="Close" @click="closeModal('interactive-consumable-modal')">
                                <font-awesome-icon :icon="['fas', 'times']" />
                            </button>
                        </template>
                        <template v-slot:default>
                            <div class="embed-responsive embed-responsive-16by9">
                                <iframe width="100%" height="auto" src="https://www.youtube.com/embed/ffyDuGb9Sjo" frameborder="0" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
                            </div>
                        </template>
                    </b-modal>
                </div>
            </div>
        </section>
</template>

<script>
export default {
    data: () => ({

    }),
    props: ['block'],
    components: {

    },
    methods: {
        showModal (modal) {
            this.$bvModal.show(modal)
        },
        closeModal (modal) {
            this.$bvModal.hide(modal)
        }
    },
    mounted () {

    }
}
</script>
